/* eslint-disable no-console */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
// import { jwtDecode } from 'jwt-decode';
import { useAuth0 } from '@auth0/auth0-react';
import { setLoginSuccess } from '../reducers/userSessionSlice';
import { resetApplicationStore } from '../common/redux/purgeStore';
import { resetGlobalInterceptors } from '../components/AxiosInterceptors/AxiosInterceptors';
import { useAppSelector } from '../reducers/rootReducer';
import { selectInterceptorsStatus } from '../reducers/interceptorsSlice';
import { getVectorConfiguration } from '../reducers/vectorConfigurationSlice';
// import { featureFlags } from '../components/App/App';
// import { checkFeatureFlag } from '../reducers/featureFlagSlice';

//  interface Auth0JwtPayload {
//   username: string;
//   email: string;
//   sub: string;
//   aud: string;
//   exp: number;
//   iat: number;
// }

export default function useAuth0WithRedux() {
  const dispatch = useDispatch();
  const {
    isAuthenticated,
    isLoading,
    user,
    getAccessTokenSilently,
    logout: auth0Logout,
    loginWithRedirect,
  } = useAuth0();
  const isLoggedIn = useAppSelector((state) => state.userSession.isLoggedIn);
  const interceptorsStatus = useAppSelector(selectInterceptorsStatus);
  useEffect(() => {
    const handleAuthStateChange = async () => {
      console.log('🔐 useAuth state check:', {
        isAuthenticated,
        pathname: window.location.pathname,
      });
      const isLogoutPage = window.location.pathname === '/logout';
      if (
        isAuthenticated &&
        !isLogoutPage &&
        isLoggedIn === false &&
        interceptorsStatus === 'initialized'
      ) {
        try {
          console.log('User authenticated, getting token...');
          // Get access token silently
          const accessToken = await getAccessTokenSilently();
          // const decodedToken = jwtDecode<Auth0JwtPayload>(accessToken);

          // Decode the token to get user info
          dispatch(
            setLoginSuccess({
              username: user?.email || '',
              accessToken,
              refreshToken: '', // Auth0 handles refresh automatically
              userRoles: [],
            }),
          );
          dispatch(getVectorConfiguration());
          // dispatch(
          //   checkFeatureFlag({
          //     flagNames: featureFlags,
          //     currentUser: user?.email || '',
          //   }),
          // );
        } catch (error) {
          console.error('Error getting access token:', error);
        }
      }
    };

    handleAuthStateChange();
  }, [
    isAuthenticated,
    user,
    dispatch,
    getAccessTokenSilently,
    interceptorsStatus,
  ]);

  const logout = async () => {
    console.log('Initiating logout...');
    auth0Logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    }).then(() => {
      console.log('Auth0 logout completed');
      resetGlobalInterceptors();
      dispatch(resetApplicationStore());
    });
  };

  return {
    isAuthenticated,
    isLoading,
    user,
    login: loginWithRedirect,
    logout,
    getAccessTokenSilently,
  };
}
